import { render, staticRenderFns } from "./childrenComment.vue?vue&type=template&id=29d5f7d8"
import script from "./childrenComment.vue?vue&type=script&lang=js"
export * from "./childrenComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports